import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CartState {
  cartId: string | null;
  isOpen: boolean;
  itemCount: number;
}

const initialState: CartState = {
  cartId: localStorage.getItem('cartId'),
  isOpen: false,
  itemCount: 0,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartId: (state, action: PayloadAction<string>) => {
      state.cartId = action.payload;
      localStorage.setItem('cartId', action.payload);
    },
    openCart: (state) => {
      state.isOpen = true;
    },
    closeCart: (state) => {
      state.isOpen = false;
    },
    toggleCart: (state) => {
      state.isOpen = !state.isOpen;
    },
    updateItemCount: (state, action: PayloadAction<number>) => {
      state.itemCount = action.payload;
    },
    clearCart: (state) => {
      state.cartId = null;
      state.itemCount = 0;
      state.isOpen = false;
      localStorage.removeItem('cartId');
    },
  },
});

export const {
  setCartId,
  openCart,
  closeCart,
  toggleCart,
  updateItemCount,
  clearCart,
} = cartSlice.actions;

export default cartSlice.reducer;